// @flow
import hasPermission from '../globalFunctions/hasPermission';

export default {
  name: 'termoReport',
  path: '/termoReport',
  meta: {
    breadcrumbs: [
      {
        text: 'Novo Smart',
        name: 'Dashboard'
      },
      {
        text: 'Termo Contingencial',
        name: 'TermoContingencial'
      },
      {
        text: 'Relatório Volumetria',
        name: 'termoReport'
      }
    ]
  },
  component: () => import('modules/term/report.vue'),
  beforeEnter: (to, from, next) => {
    if (hasPermission('web.term.relatorio.download')) {
      next();
    } else {
      next('/');
    }
  }
};
